import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import { RentalPortalListingStatusBadge } from '../../../../RentalPortalListing'
import { ButtonSelect } from '../../../../Select'
import { useListingProfileContext } from '../RentalPortalListingProfile.hooks'

import { ListingProfileHeaderStatusSelectButton } from './ListingProfileHeaderStatusSelectButton'
import { ListingProfileHeaderStatusSelectNote } from './ListingProfileHeaderStatusSelectNote'
import { ListingProfileHeaderStatusSelectOption } from './ListingProfileHeaderStatusSelectOption'
import { QA_NAME_LISTING_PROFILE_STATUS_SELECT } from './RentalPortalListingProfileHeaderStatusSelect.constants'
import { useListingProfileStatusChange } from './RentalPortalListingProfileHeaderStatusSelect.hooks'
import {
  getIsListingStatusReadOnly,
  getListingStatusSelectOptions,
  getListingStatusSelectValue,
} from './RentalPortalListingProfileHeaderStatusSelect.utils'

import * as styles from './RentalPortalListingProfileHeaderStatusSelect.module.css'

function RentalPortalListingProfileHeaderStatusSelect({
  className,
  disabled,
  height,
  isLoading,
  textClassName,
}) {
  const { t } = useTranslation()

  const { isPreview, listingData } = useListingProfileContext()

  const { handleSelectStatus, isStatusUpdating } =
    useListingProfileStatusChange()

  const options = getListingStatusSelectOptions({ listing: listingData, t })

  return getIsListingStatusReadOnly({
    isPreview,
    options,
    status: listingData?.status,
  }) ? (
    <RentalPortalListingStatusBadge
      className={classNames(className, styles.badge)}
      height={height}
      listing={listingData}
      textClassName={textClassName}
    />
  ) : (
    <ButtonSelect
      Control={ListingProfileHeaderStatusSelectButton}
      className={className}
      controlProps={{ isSkeleton: isLoading }}
      disabled={disabled || isLoading || isStatusUpdating}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottom,
        maxWidthByRef: false,
      }}
      dropdownProps={{ className: styles.dropdown }}
      listProps={{
        Footer: ListingProfileHeaderStatusSelectNote,
        headerProps: { Search: null },
        itemProps: {
          contentProps: {
            infoProps: { ContentText: ListingProfileHeaderStatusSelectOption },
          },
        },
      }}
      options={options}
      qaName={QA_NAME_LISTING_PROFILE_STATUS_SELECT}
      tooltip={
        disabled
          ? t('RentalPortal.ListingStatusChangeNotAllowedTooltipKey')
          : null
      }
      value={getListingStatusSelectValue({ listing: listingData, t })}
      onSelectItem={handleSelectStatus}
    />
  )
}

export default RentalPortalListingProfileHeaderStatusSelect
